export default __webpack_public_path__ + "static/media/icon-close.e6d6971a.svg";